import styled from 'styled-components';
import { poshubTabsStyles } from './theme';

export const StyledWrapper = styled.div`
  ${poshubTabsStyles}
`;
